export const localBaseUrl = 'http://localhost:5007';
export const prodBaseUrl = 'https://api.mambahikers.com'
export const queryKeys = {
  destinations: "destinations",
  adventures: "adventures",
  adventure: "adventure",
  upcomingAdventures: "upcomingAdventures",
  destinationOptions: "destinationOptions",
  adventureOptions: "adventureOptions",
  lookups: "lookups",
  destinationImages: "destinationImages",
  adventureImages: "adventureImages",
  programmes: "programmes",
  upcomingProgrammes: "upcomingProgrammes",
};